/* global braintree */
import { Link } from 'react-router-dom';
import React from 'react';
import { connect } from 'react-redux';
import ListErrors from './ListErrors';
import agent from '../agent';
import { UPDATE_FIELD_AUTH, CHECKOUT_PAGE_UNLOADED, PAYMENT_SUBMITTED, INITIALIZE_CHECKOUT } from '../actionTypes';

const TOKEN =
    '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';

function selectBraintreeToken(state) {
    if (state.common.braintreeToken) {
        return state.common.braintreeToken.token && state.common.braintreeToken.token.clientToken;
    }
    return '';
}

const mapStateToProps = (state) => ({
    ...state.auth,
    braintreeToken: selectBraintreeToken(state),
    // userName: state.common.currentUser.username,
});

const styles = {
    plan: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '10px',
        border: '2px solid black',
        marginLeft: '15%',
        marginTop: '10%',
    },
    price: {
        fontSize: '24pt',
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '5%',
    },
};

const mapDispatchToProps = (dispatch) => ({
    onChangeEmail: (value) => dispatch({ type: UPDATE_FIELD_AUTH, key: 'email', value }),
    onChangePassword: (value) => dispatch({ type: UPDATE_FIELD_AUTH, key: 'password', value }),
    onChangeUsername: (value) => dispatch({ type: UPDATE_FIELD_AUTH, key: 'username', value }),
    onSubmit: (payload) => dispatch({ type: PAYMENT_SUBMITTED, payload }),
    onLoad: () => {
        // const token = agent.Payment.token({});
        dispatch({ type: INITIALIZE_CHECKOUT, payload: 'token' });
    },
    onUnload: () => dispatch({ type: CHECKOUT_PAGE_UNLOADED }),
});

class Checkout extends React.Component {
    constructor() {
        super();
        this.changeEmail = (ev) => this.props.onChangeEmail(ev.target.value);
        this.changePassword = (ev) => this.props.onChangePassword(ev.target.value);
        this.changeUsername = (ev) => this.props.onChangeUsername(ev.target.value);
        this.onSubmit = (ev) => this.props.onSubmit(ev.target.value);
        this.onLoad = () => this.props.onLoad();

        this.braintreeToken = this.props && this.props.braintreeToken;

        // this.loadBraintree = this.props.loadBraintree
        // this.submitForm = (username, email, password) => ev => {
        //   ev.preventDefault();
        //   this.props.onSubmit(username, email, password);
        // }
    }

    UNSAFE_componentWillMount() {
        console.log('test');
        this.onLoad();
        console.log('this.props: ', this.props);
    }

    componentWillReceiveProps(nextProps) {
        console.log('nextProps: ', nextProps);
        this.braintreeToken = nextProps && nextProps.braintreeToken;
        const userName = nextProps && nextProps.userName;
        const { onSubmit } = this.props;
        if (window.braintree) {
            const button = document.querySelector('#paymentSubmit');
            window.braintree.dropin.create(
                {
                    authorization: TOKEN, // this.braintreeToken,
                    container: '#dropin-container',
                    paypal: {
                        flow: 'vault',
                    },
                },
                (createErr, instance) => {
                    button.addEventListener('click', () => {
                        instance.requestPaymentMethod((requestPaymentMethodErr, payload) => {
                            // Submit payload.nonce to your server
                            console.log('all good');
                            console.log('payload: ', payload);
                            const req = {
                                details: payload.details,
                                paymentNonce: payload.nonce,
                                // userName,
                            };
                            console.log('req: ', req);

                            // Need to handle payment errors
                            const promise = agent.Payment.pay(req);
                            onSubmit(promise);
                        });
                    });
                },
            );
        }
    }

    componentDidMount() {
        console.log('braintree: ', braintree);
        console.log('this.props: ', this.props);
        if (window.braintree) {
            // alternate braintree version
            //   window.braintree.setup(TOKEN, 'dropin', {
            //     container: 'dropin-container',
            //   });
            // }
            // const button = document.querySelector('#paymentSubmit')
            // window.braintree.dropin.create({
            //     authorization: this.braintreeToken,
            //     container: '#dropin-container',
            //     // paypal: {
            //     //     flow: 'vault'
            //     // }
            //   }, function (createErr, instance) {
            //     button.addEventListener('click', function () {
            //       instance.requestPaymentMethod(function (requestPaymentMethodErr, payload) {
            //         // Submit payload.nonce to your server
            //         console.log("all good")
            //         console.log("payload: ", payload)
            //         // Need to handle payment errors
            //         // const promise = agent.Payment.pay({
            //         //   details: payload.details,
            //         //   paymentNonce: payload.nonce
            //         // })
            //         // this.props.onSubmit(promise);
            //       });
            //     });
            // })
        }
    }

    componentWillUnmount() {
        this.props.onUnload();
    }

    render() {
        const { email } = this.props;
        const { password } = this.props;
        const { username } = this.props;

        return (
            <div className="auth-page">
                <div className="container page">
                    <div className="row" style={{ display: 'flex', justifyContent: 'center', padding: '30px' }}>
                        <div className="row" style={styles.row}>
                            <form>
                                <div id="dropin-container" />
                            </form>
                        </div>
                        <div className="row" style={styles.row}>
                            <div className="free-plan" style={styles.plan}>
                                <div className="benefits">
                                    <ul id="1">Regular $12.99 / month</ul>
                                    <ul id="2">$3.99 / month</ul>
                                    <ul id="3">Instant access</ul>
                                </div>
                                <div className="action">
                                    <button
                                        className="btn btn-lg pull-xs-right btn-primary"
                                        id="paymentSubmit"
                                        type="button"
                                        style={{ borderRadius: '2rem', fontSize: '1rem', marginRight: '5px' }}
                                        disabled={this.props.inProgress}
                                    >
                                        Select
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);
